'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path stroke="#4F4E65" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12.5 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6" /><rect width={19} height={22} x={3} y={1} stroke="#4F4E65" strokeWidth={2} rx={2} /><path stroke="#4F4E65" strokeLinecap="round" strokeWidth={2} d="M1.5 8h3M1.5 12h3M1.5 16h3" /><mask id="contacts-navigation_svg__a" fill="#fff"><path d="M6.5 18a6 6 0 0 1 12 0z" /></mask><path fill="#4F4E65" d="M4.5 18a8 8 0 1 1 16 0h-4a4 4 0 0 0-8 0zm14 0h-12zm-14 0a8 8 0 0 1 8-8v4a4 4 0 0 0-4 4zm8-8a8 8 0 0 1 8 8h-4a4 4 0 0 0-4-4z" mask="url(#contacts-navigation_svg__a)" /></svg>;
const IconContactsNavigation = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconContactsNavigation;